import { useI18n } from 'context/i18n';
import { useLocale } from 'hooks';
import Head from 'next/head';
import { useMemo } from 'react';
import { getUnbxdTranslations } from 'utils/helpers';

export function SearchBoxJson() {
  const { t } = useI18n();
  const { language, country } = useLocale();
  const unbxdTranslations = useMemo(() => getUnbxdTranslations(t), [t]);
  const usesNewSearch = unbxdTranslations !== false;
  if (!usesNewSearch) {
    return null;
  }
  return (
    <Head>
      <script
        key="search-box-json"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            url: `https://www.camper.com/${language}_${country}`,
            potentialAction: {
              '@type': 'SearchAction',
              target: {
                '@type': 'EntryPoint',
                urlTemplate: `https://www.camper.com/${language}_${country}/search?searchTerm={search_term_string}`,
              },
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
    </Head>
  );
}
